/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Subtext_Rest_Is_FineInputs */



/**
* | output |
* | --- |
* | "No worries, the rest of the app is fine. Probably." |
*
* @param {Error_Subtext_Rest_Is_FineInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_subtext_rest_is_fine = /** @type {((inputs?: Error_Subtext_Rest_Is_FineInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Subtext_Rest_Is_FineInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Sorge, der Rest der App läuft. Wahrscheinlich.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas d'inquiétude, le reste de l'appli va bien. Sans doute.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("别担心，其余部分都还正常。大概吧。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("別擔心，其他部分都還好。大概吧。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("걱정 마세요, 나머지 기능은 멀쩡합니다. 아마도요.")
	return /** @type {LocalizedString} */ ("No worries, the rest of the app is fine. Probably.")
});